import React, { FunctionComponent } from 'react';
import { ThemeProvider } from 'styled-components';
import cuiTheme from '../styles/theme';

export interface LayoutProps {
  children: React.ReactNode | React.ReactChild;
  theme?: any;
}

const Layout: FunctionComponent<LayoutProps> = ({
  children,
  theme,
  ...other
}) => (
  <ThemeProvider theme={theme || cuiTheme} {...other}>
    {children}
  </ThemeProvider>
);

export default Layout;
